import { render } from "./RCheckbox.vue?vue&type=template&id=4a254413"
import script from "./RCheckbox.vue?vue&type=script&lang=js"
export * from "./RCheckbox.vue?vue&type=script&lang=js"

import "./RCheckbox.vue?vue&type=style&index=0&id=4a254413&lang=css"
script.render = render

export default script